@let typeValue = type();
@let resultValue = result();

@switch (typeValue) {
  @case ('audio') {
    <ng-container [ngTemplateOutlet]="audio"></ng-container>
  }
  @case ('video') {
    <ng-container [ngTemplateOutlet]="video"></ng-container>
  }
}

<ng-template #audio>
  <h3 class="mb-2 text-xl">Audio</h3>
  <p class="my-2"><strong>Quality: </strong> {{ resultValue.mos | number: '1.0-1' }}</p>
  <p class="my-2">
    <strong>Bitrate (average): </strong>
    {{ $safeNavigationMigration(resultValue.complete?.audio?.bitrate) | toKbps }} Kbps
  </p>
  <p class="my-2">
    <strong>Packet loss ratio: </strong>
    {{ (resultValue.complete?.audio?.packetLossRatio || 0) * 100 }} %
  </p>
</ng-template>

<ng-template #video>
  <h3 class="mb-2 text-xl">Video</h3>
</ng-template>
